if (!customElements.get('wish-list-notification')) {
    class WishListNotification extends HTMLElement {
        show() {
            this.resetState();
            this.style.display = 'block';
            setTimeout(() => {
                this.hide()
            }, 1200);
        }

        /**
         * @param info
         */
        modifyContent(info) {
            this.modalContent = this.querySelector('[id^="WishListNotificationContent-"]');
            if (info.name) this.modalContent.querySelector('[data-title]').textContent = info.name;
            if (info.image) this.modalContent.querySelector('[data-image]').src = info.image;
        }

        resetState() {
            document.querySelectorAll('wish-list-notification').forEach((notification) => {
                notification.style.display = 'none';
            })
        }

        hide() {
            this.style.display = 'none';
        }
    }

    customElements.define('wish-list-notification', WishListNotification);
}